import { StoriesStateType, StoriesType } from "./types";
import { compact, concat, keyBy, last, map, orderBy, uniq } from "lodash";
import { createReducer } from "@reduxjs/toolkit";
import { addStoryView, deleteStory, setStoriesList, updateSeenStory, updateStoriesList, updateStoryView } from "./actions";

const initialState: StoriesStateType = {
  stories: {},
  storyList: [],
  storyViewedList: {},
  unreadCount: 0,
};

const sortStoryList = (stories: StoriesType) => orderBy(stories, [(story) => last(story.storiesList)?.createdAt], "desc");

export const storiesReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setStoriesList, (state, action) => {
      const stories = {
        ...state.stories,
        ...keyBy(action.payload, "originatorId"),
      };
      state.stories = stories;
      state.storyList = compact(map(sortStoryList(stories), "originatorId").filter((item) => item !== null));
    })
    .addCase(updateStoriesList, (state, action) => {
      //TO_DO
      state.stories[action.payload.originatorId].storiesList = compact(uniq(concat(state.stories[action.payload.originatorId]?.storiesList, action.payload?.story)));
      state.storyList = compact(map(sortStoryList(state.stories), "originatorId").filter((item) => item !== null));
    })
    .addCase(updateSeenStory, (state, action) => {
      state.stories[action.payload.storyOwnerUserId].storiesList = compact(
        state.stories[action.payload.storyOwnerUserId]?.storiesList?.map((story) =>
          story?.id === action.payload.storyId
            ? {
                ...story,
                seen: true,
              }
            : story
        )
      );
      state.storyViewedList[action.payload.storyId] = {
        ...state.storyViewedList[action.payload.storyId],
        views: +state.storyViewedList[action.payload.storyId]?.views + 1 || 1,
      };
    })
    .addCase(deleteStory, (state, action) => {
      const userStoryList = compact(state.stories[action.payload.userId]?.storiesList.filter((story) => story && story.id !== action.payload.storyId) || []);
      state.storyList = !userStoryList.length ? state.storyList.filter((userId) => userId !== action.payload.userId) : state.storyList;
      state.stories[action.payload.userId].storiesList = userStoryList;
    })
    .addCase(addStoryView, (state, action) => {
      state.storyViewedList = {
        ...state.storyViewedList,
        ...keyBy(action.payload, "storyId"),
      };
    })
    .addCase(updateStoryView, (state, action) => {
      state.storyViewedList[action.payload].views = +state.storyViewedList[action.payload]?.views + 1 || 1;
    });
});
